import styled, { css } from 'styled-components';
import DataTable from '@/components/DataTable';

const ColStyle = css`
  padding: ${({ theme }) => theme.x1spacePx}px 12px;
  text-align: right;
  &:first-child {
    text-align: left;
  }
`;

export const DividendYieldTable = styled(DataTable)`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
  thead tr th {
    ${({ theme }) => theme.typography.tinyStrong};
    height: ${({ theme }) => theme.x4spacePx}px;
    background: ${({ theme }) => theme.color.darkerGray};
  }
  th {
    position: sticky;
    top: 0px;
    z-index: 1;
    ${ColStyle}
  }
  td {
    white-space: nowrap;
    vertical-align: middle;
    ${ColStyle}
  }
  caption {
    text-align: left;
  }
`;

export const HeaderDataTable = styled(DividendYieldTable)`
  border-bottom: none;
`;
